import React from "react";

export default function InformationRibonMobile(props) {
  return (
    <div className="ribon-information-mobile">
      {props.infoLabel}: {props.labelContent}
    </div>
  );
}
